(function (document) {
  
    function respondToVisibility(element, callback) {
          var options = { root: document };
          var observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
              callback(entry.intersectionRatio > 0);
          });
          }, options);
      
          observer.observe(element);
      }
  
      function changeBackdropVisibility(visible) {
          var html = document.documentElement;
          var backdropEl = document.getElementById("CybotCookiebotDialogBackdrop");
          document.body.style.paddingTop = "";
          
          if(visible) {
              var cookieBotDialogZIndex = window.getComputedStyle(document.getElementById("CybotCookiebotDialog")).zIndex;
              var backdropZIndex = parseInt(cookieBotDialogZIndex) - 1;
              backdropEl.style.display = "block";
              backdropEl.style.zIndex = backdropZIndex;
              html.style.overflow = "hidden";
          }
          else {
              backdropEl.style.display = "none";
              html.style.overflow = "unset";
          }
      }
  
    
    const targetNode = document.body;
    const config = { attributes: false, childList: true, subtree: true };
  
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          var addedNodes = Array.from(mutation.addedNodes);
          var cookiebot = addedNodes.find((node) =>  node.id === "CybotCookiebotDialog")
          if(cookiebot) {
            respondToVisibility(cookiebot, changeBackdropVisibility);
          }
        }
      }
    };
  
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  
    
  })(window.document);
  
